import React from "react";
import { useSelector } from "react-redux";
import { Typography, Button } from "@material-ui/core";
import SmsIcon from "@material-ui/icons/Sms";
import FolderIcon from "@material-ui/icons/Folder";
import { Root, User } from "../../styles";
import TimeStats from "../time-stats";
import IconItems from "../../../../components/app-bar/components/icon-items";
import Link from "../../../../components/plain-link";
import ProfilePicture from "../../../../components/profile-picture";
import useStyles from "./styles";

const UserProfile = () => {
  const classes = useStyles();
  const username = useSelector((state) => state.groupsBuddiesData.username);
  const isBuddy = useSelector((state) => state.groupsBuddiesData.isBuddy);
  const profilePicture = useSelector(
    (state) => state.groupsBuddiesData.profilePicture
  );
  const displayName = useSelector(
    (state) => state.groupsBuddiesData.displayName
  );
  const lastActiveTime = useSelector(
    (state) => state.groupsBuddiesData.lastActiveTime
  );
  const studyTime = useSelector((state) => state.groupsBuddiesData.studyTime);
  const icons = [
    { icon: <SmsIcon />, link: "/" },
    { icon: <FolderIcon />, link: "/" },
  ];

  return (
    <Root>
      <User>
        <ProfilePicture
          picturePath={profilePicture}
          className={classes.profilePicture}
        />
        <div className={classes.displayNameGroup}>
          <Typography variant="h1" className={classes.displayName}>
            {displayName}
          </Typography>
          {isBuddy ? (
            <IconItems
              icons={icons}
              iconStyle={classes.iconStyle}
              groupStyle={classes.groupStyle}
            />
          ) : (
            <div></div>
          )}
        </div>
        <Typography className={classes.username}>
          username: {username}
        </Typography>
        <Typography className={classes.lastActive}>
          Last active: {lastActiveTime} seconds ago
        </Typography>
        {isBuddy ? (
          <div></div>
        ) : (
          <Link to="/">
            <Button className={classes.request}>Request Buddy</Button>
          </Link>
        )}
      </User>
      <div className={classes.displayStats}>
        <TimeStats time={studyTime} />
      </div>
    </Root>
  );
};

export default UserProfile;
